import routes from './routes/news.routes.js';
import ModuleBase from '../../classes/ModuleBase.js';

export default new ModuleBase({
    name: 'News',
    routes: routes,
    components: [

    ]
});